/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PermissionGroups {
    Temp = 101000,
    Employee = 102000,
    Customer = 103000,
    Order = 104000,
    Product = 105000,
    Other = 106000,
    Technical = 107000,
    MenuItem = 108000,
    Applications = 109000,
    Project = 110000,
    Configurator_Attribute = 111000,
    Configurator_Rule = 112000,
    Data_Import = 113000,
    Instruction = 114000,
}
